import React from "react";
import {MyTable,MyTableHead,MyTableTr,MyTableTh,MyTableTd,MyTableBody} from '../../components/table/index'
import "./repertoryWarning.scss"
import {PDscroll,pageSize} from '../../utils/index'
import {stockWarningStatistic,stockWarning} from "../../api/index"
import { Toast } from 'antd-mobile';
export default class RepertoryWarning extends React.Component{
    constructor(props){
        super(props);
        this.state={
            numReturn:0,
            pageNumber:1,
            activeLi:"all",
            listData:[],
            statusArray:[
                {
                    name:"全部库存",
                    color:"#0486FE",
                    type:'all'
                },
                {
                    name:"缺货状态",
                    color:"#410ADF",
                    type:'day1'
                },
                {
                    name:"紧急状态",
                    color:"#F42850",
                    type:'day5'
                },
                {
                    name:"要紧订单",
                    color:"#F6A93B",
                    type:'day10'
                },
                {
                    name:"可能缺货",
                    color:"#7ED321",
                    type:'day15'
                },
                {
                    name:"正常库存",
                    color:"#4A90E2",
                    type:'other'
                }
            ],

        }
        
    }
    
    render(){
        const tableHeadData=[
            {
                name:"耗材名称",
                
            },
            {
                name:"现有库存",
                
            },
            {
                name:"状态",
                
            },
        ]
        return(
            <div className="repertoryWarning">
                <div className="statusWrap">
                    <ul>
                        {
                            this.state.statusArray.map((s)=>{
                                return <li onClick={()=>{this.changeType(s.type)}} style={{background:this.state.activeLi==s.type?s.color:''}}>
                                <div  style={{background:this.state.activeLi==s.type?'#fff':s.color}} className="doot"></div>
                                <span style={{color:this.state.activeLi==s.type?'#fff':s.color}}  className="title">{s.name}</span>
                                <p  style={{color:this.state.activeLi==s.type?'#fff':s.color}} >{s.num}</p>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className="daytext">
                    <span>
                    *平均值范围5天*
                    </span>
                </div>
                <div className="tableWrap">
                    <MyTable>
                        <MyTableHead>
                            <MyTableTh>{"耗材名称"}</MyTableTh>
                            <MyTableTh>{"现有库存"}</MyTableTh>
                            <MyTableTh>{"状态"}</MyTableTh>
                        </MyTableHead>
                        <MyTableBody>
                        {this.state.listData.map((s)=>{
                            return (
                                <MyTableTr>
                                    <MyTableTd>
                                        <span>{s.name}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.dayDiff}</span>
                                    </MyTableTd>
                                    <MyTableTd>
                                        <span>{s.status}</span>
                                    </MyTableTd>
                                </MyTableTr>
                            )
                        })}
                        </MyTableBody>
                    </MyTable>
                </div>
            </div>
            
        )
    }
    changeType(type){
        this.setState({
            activeLi:type,
            pageNumber:1
        },()=>{
            this.getListData(true)
        })
    }
    async getListData(inits){
        let obj={
            type: this.state.activeLi,
            pageSize: pageSize,
            pageNumber: this.state.pageNumber,
             
            day1: 5
        }
        Toast.loading("加载中...",5000)
        let res=await stockWarning(obj) 
        if(res.code==0){
            Toast.hide();
            res.data.records.forEach((v)=>{
                if(v.quantity<v.dayAverageConsume){
                    v.status="缺货状态"
                  }else if(v.quantity<v.day5AverageConsume){
                    v.status="紧急状态"
                  }else if(v.quantity<v.day10AverageConsume){
                    v.status="要紧订单"
                  }else if(v.quantity<v.day15AverageConsume){
                    v.status="可能缺货"
                  }else{
                    v.status="正常库存"
                  }
            })
            this.setState({
                numReturn:res.data.records.length
            })
            if(inits){
                this.setState({
                    listData:res.data.records
                })
            }else{

                this.setState({
                    listData:this.state.listData.concat(res.data.records)
                })
            }
            
        }else{
            Toast.fail(res.msg,3)
        }
    }
    async componentDidMount(){
        PDscroll('contenthome',()=>{
            this.setState({
                pageNumber:this.state.pageNumber+1
            },()=>{
                if(this.state.numReturn==pageSize){
                    
                    this.getListData();
                }else{
                    Toast.fail("暂无更多",1)
                }
                
            })
        },1)
        console.log("11123123",document.getElementsByClassName("statusWrap")[0])
        let Height=document.documentElement.clientHeight;
        let Height1=document.getElementsByClassName("statusWrap")[0].style.offsetheight;
        let Height2=document.getElementsByClassName("daytext")[0].style.offsetheight;
        let Height3=document.getElementsByClassName("MyTableHead")[0].style.offsetheight;
        console.log(Height,Height1,Height2,Height3);
        let Height4=Height-Height1-Height2-Height3;
        let bodys=document.getElementsByClassName("tableWrap")[0];
        bodys.style.height=Height4+'px';
        let res=await stockWarningStatistic({day1:5});
        if(res.code==0){
            this.setState({
                statusArray:[
                    {
                        name:"全部库存",
                        color:"#0486FE",
                        num:res.data.all,
                        type:"all"
                    },
                    {
                        name:"缺货状态",
                        color:"#410ADF",
                        num:res.data.day1,
                        type:"day1"
                    },
                    {
                        name:"紧急状态",
                        color:"#F42850",
                        num:res.data.day5,
                        type:"day5"
                    },
                    {
                        name:"要紧订单",
                        color:"#F6A93B",
                        num:res.data.day10,
                        type:"day10"
                    },
                    {
                        name:"可能缺货",
                        color:"#7ED321",
                        num:res.data.day15,
                        type:"day15"
                    },
                    {
                        name:"正常库存",
                        color:"#4A90E2",
                        num:res.data.other,
                        type:"other"
                    }
                ]
            })
        }else{
            Toast.fail(res.msg,3)
        }
        this.getListData();
        
    }
}

